import React from 'react';
import AppButton from '../../components/Buttons/AppButton/AppButton';
import './ModalFooterWithButtons.scss';

type Props = {
   actionButtonLabel: string;
   actionButtonDisabled?: boolean;
   actionButtonLoading?: boolean;
   cancelButtonLabel: string;
   onActionButtonClick: () => void;
   onCancel?: () => void;
   cancelButtonDisabled?: boolean;
};

const ModalFooterWithButtons: React.FC<Props> = (props) => {
   const {
      actionButtonLabel,
      actionButtonDisabled,
      actionButtonLoading,
      onActionButtonClick,
      cancelButtonLabel,
      onCancel,
      cancelButtonDisabled,
   } = props;

   return (
      <div className={'modal-footer-with-buttons'}>
         {onCancel && (
            <AppButton onClick={onCancel} theme={'link'} type={'button'} disabled={cancelButtonDisabled}>
               {cancelButtonLabel}
            </AppButton>
         )}

         <AppButton onClick={onActionButtonClick} disabled={actionButtonDisabled} isLoading={actionButtonLoading} type={'button'}>
            {actionButtonLabel}
         </AppButton>
      </div>
   );
};

export default ModalFooterWithButtons;
